import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Product {
  documentOwner: string;
  id: number;
  description: string;
  quantity: number;
  unitPrice: number;
  promotionPrice: number;
  promotionFinalDate: string;
}

interface ProductsState {
  products: Product[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProductsState = {
  products: [],
  isLoading: false,
  error: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts(state, action: PayloadAction<Product[]>) {
      state.products = action.payload;
      state.error = null;
    },
    clearProducts(state) {
      state.products = [];
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { setProducts, clearProducts, setLoading, setError, clearError } =
  productsSlice.actions;
export default productsSlice.reducer;
